import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenUp = function ArrowCircleBrokenUp(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7 20.6621c-2.989-1.7291-5-4.9608-5-8.6622 0-5.5229 4.4772-10 10-10s10 4.4771 10 10c0 3.7014-2.011 6.9331-5 8.6622m-1-8.6622-4-4m0 0-4 4m4-4v14"
    })
  }));
};
export default ArrowCircleBrokenUp;